<template>
  <client-only>
    <v-flex text-center id="like-job-btn">
      <v-btn
        aria-haspopup="true"
        text
        class="pa-0 mx-2 add-job-to-favorites large"
        ref="jobCode"
        @click.prevent="setCookie()"
        :loading="loading"
        :disabled="disableOnMandatory"
        :title="tooltip"
      >
        <v-icon
          right
          primary--color
          ref="likeIcone"
          class="ma-0"
          :class="[isFavorite ? 'icon-like-on ' : 'icon-like']"
          color="primary"
          cy-data="add-to-favorites"
        ></v-icon>
      </v-btn>
    </v-flex>
  </client-only>
</template>

<script>
import SmileyOptions from '@/lib/enums/SmileyOptions';
import { mapActions, mapState } from 'vuex';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import CurrentUser from '@/components/mixins/CurrentUser';
import drushim_lodash from 'lodash';

export default {
  mixins: [CurrentUser],
  data() {
    return {
      isSet: false,
      loading: false,
      tooltipOn: false,
      tooltip: t('tooltips.addToFavorites'),
    };
  },
  props: {
    disableOnMandatory: {
      type: Boolean,
      default: false,
    },
    recomendedJob: {
      type: Boolean,
      required: false,
      default: false,
    },
    currentPage: {
      type: String,
      required: false,
      default: '',
    },
    jobName: {
      type: String,
      required: false,
      default: '',
    },
    JobId: {
      type: String,
      required: false,
      default: '',
    },
    JobPosition: {
      type: String,
      required: false,
      default: '',
    },

    isFavorite: {
      type: Boolean,
    },
    jobIndex: {
      type: Number,
    },
    jobCode: { Number, required: true, default: null },
  },
  computed: {
    ssa() {
      return drushim_lodash.get(this.$ssa, 'vm', {});
    },

    ...mapState({ jobsBasket: (state) => state.authUser.jobsBasket }),
  },

  methods: {
    sendSSA(eventName, jobcode, jobindex) {
      this.ssa.log('LogSSA', {
        eventName: eventName,
        jobcode: jobcode,
        jobindex: jobindex,
      });
    },
    sendSSAResponse(evenData) {
      this.ssa.logResponse('LogSSA', evenData);
    },
    ...mapActions({
      addJobToFavorites: 'addJobToFavorites',
      removeJobFromFavorites: 'removeJobFromFavorites',
      updateJobBasket: 'updateJobBasket',
    }),
    showTooltip() {
      this.$nuxt.$emit('showsnack');
    },

    setCookie() {
      this.loading = true;

      if (this.isLogged) {
        let postdata = {
          JobCodes: new Array(1).fill(this.jobCode),
          Status: SmileyOptions.Like,
          IsRemove: this.isFavorite,
        };

        this.updateJobBasket(postdata).then(() => {
          this.loading = false;

          if (!this.isFavorite) {
            this.sendSSA('ListingAddedToOAFBulk', this.jobCode, this.jobIndex);
            this.showTooltip();
          } else {
            this.$bus.$emit('updateSendList', this.jobCode);
          }
        });
      } else {
        /**
         * In case user not logged in , will update the store and cookies
         */
        if (!this.isFavorite) {
          this.sendSSA('ListingAddedToOAFBulk', this.jobCode, this.jobIndex);
          this.addJobToFavorites(this.jobCode);
          this.loading = false;
          this.showTooltip();
        } else {
          this.removeJobFromFavorites(this.jobCode);
        }

        this.loading = false;
      }

    },
  },
};
</script>

<style lang="scss" scoped>
#like-job-btn i {
  font-size: 20px;
}
.icon-like,
.icon-like-on {
  transition: all 1s;
}

#like-job-btn .v-btn:not(.v-btn--round).v-size--default {
  min-width: auto;
}
.icon-like-on:hover,
.icon-like:hover {
  opacity: 0.8;
}

@media screen and (min-width: 600px) {
  #like-job-btn i {
    font-size: 22px;
  }
}
</style>
